import { createSlice } from "@reduxjs/toolkit";
import { deepMerge } from "../utils/helper";

export const i18nSlice = createSlice({
  name: "i18n",
  initialState: {
    tracking_form: {
      title: "Track your order",
      order_id: "Order ID",
      email: "Email",
      or: "OR",
      tracking_number: "Tracking Number",
      button: "Track",
      plh_order_id: "Enter your order name",
      plh_email: "Enter your email",
      plh_tracking_number: "Enter your tracking number",
      order_not_found: "Order not found",
      empty_email: "Please provide email",
      invalid_email: "Invalid email",
      empty_tracking_number: "Please fill in tracking number",
      empty_order_name: "Please fill in order name",
    },
    tracking_history: {
      shipment_information: "Shipment Information",
      shipping_address: "Shipping address",
      tracking_number: "Tracking number",
      shipment_history: "Shipment history",
      carrier: "Carrier",
    },
    progress_bar: {
      status: "Status",
    },
    order_details: {
      shipment_items: "Items of shipment",
      product: "Products",
      total_price: "Total",
      item_singular: "item",
      item_plural: "items",
    },
    review: {
      button_text: "Review us",
      review_title: "Your satisfaction is Our Biggest Rewards",
    },
    footer: {
      privacy: "Privacy",
      return: "Return",
      supportt: "Support",
      term: "Term",
    },
  },
  reducers: {
    setI18n: (state, action) => {
      const convertI18n = action.payload;
      return deepMerge(
        state,
        window.dynamicReview ? window.dynamicReview["i18n"] : convertI18n
      );
    },
    overrideI18n: (state, action) => {
      return deepMerge(state, action.payload);
    },
  },
});

export const { setI18n, overrideI18n } = i18nSlice.actions;
export default i18nSlice.reducer;
